var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      width: 256,
      height: 256,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\n\t.st0{fill:#4B4B4B;}\n\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.016,138.656v13.5h39.063c28.516,0,58.266,7.219,82.828,19.5v-14.844 c-25.156-11.531-54.375-18.156-82.828-18.156H89.016z",
    style: {
      fill: "rgb(13, 92, 167)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.016,192.953v13.5h39.063c28.516,0,58.266,7.141,82.828,19.484v-14.906 c-25.156-11.531-54.375-18.078-82.828-18.078H89.016z",
    style: {
      fill: "rgb(13, 92, 167)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.016,247.188v13.5h39.063c28.516,0,58.266,7.219,82.828,19.547v-14.891 c-25.156-11.547-54.375-18.094-82.828-18.156H89.016z",
    style: {
      fill: "rgb(13, 92, 167)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.109,319.625v14.922c24.484-12.297,54.297-19.516,82.766-19.516H423v-13.469h-39.125 C355.469,301.563,326.266,308.156,301.109,319.625z",
    style: {
      fill: "rgb(13, 92, 167)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.016,301.484v13.484h39.063c28.516,0,58.266,7.219,82.828,19.516v-14.922 c-25.156-11.469-54.375-18.078-82.828-18.078H89.016z",
    style: {
      fill: "rgb(13, 92, 167)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M493.406,48.75h-97.5c-28.813,0.063-58.406,6.125-85.625,17.547c-20.781,8.719-39.016,19.922-54.297,33.359 c-15.328-13.438-33.547-24.641-54.281-33.359C174.5,54.875,144.906,48.813,116.078,48.75h-97.5C8.344,48.75,0,57.078,0,67.328 v325.375c0,10.25,8.344,18.578,18.578,18.578h97.5c23.078,0,47.984,5.109,70.094,14.391c20.313,8.484,40,21.609,52.672,35.141 l2.281,2.438h29.75l2.266-2.438c12.656-13.5,32.328-26.641,52.625-35.141c22.484-9.422,46.734-14.391,70.141-14.391h97.5 c10.25,0,18.594-8.328,18.594-18.578V67.328C512,57.078,503.656,48.75,493.406,48.75z M248.313,420.297 c-13.141-10.578-28.203-19.328-44.188-26.234c-25.391-10.813-53.406-16.891-80.953-16.891H40.813V77.594h82.359 c24.031,0,49.078,5.422,71.547,15.047c21.063,8.922,39.797,21.609,53.594,36.641V420.297z M471.188,377.25h-82.375 c-27.531,0-55.531,6.063-80.938,16.891c-16.063,6.891-31.047,15.641-44.188,26.156V129.344 c13.797-15.031,32.531-27.719,53.531-36.625c22.531-9.641,47.563-15.063,71.594-15.063h82.375V377.25z",
    style: {
      fill: "rgb(13, 92, 167)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.109,156.875v14.844c24.484-12.281,54.297-19.5,82.766-19.5H423v-13.484h-39.125 C355.469,138.734,326.266,145.344,301.109,156.875z",
    style: {
      fill: "rgb(13, 92, 167)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.109,211.094v14.922c24.484-12.359,54.297-19.5,82.766-19.5H423v-13.484h-39.125 C355.469,193.031,326.266,199.563,301.109,211.094z",
    style: {
      fill: "rgb(13, 92, 167)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.109,265.406v14.906c24.484-12.344,54.297-19.563,82.766-19.563H423v-13.5h-39.125 C355.469,247.328,326.266,253.875,301.109,265.406z",
    style: {
      fill: "rgb(13, 92, 167)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRule);
export default __webpack_public_path__ + "static/media/rule.ed736bcce08305117068f8e7f40a98b7.svg";
export { ForwardRef as ReactComponent };